import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceM, spaceS, xdlColorTextSecondary } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { InstantPrompt } from './instant-prompt';
import { RecentSearch } from './recent-search';
import { RECENT_SEARCHS_TITLE } from './use-suggestions';
import type { Suggestion } from './use-suggestions';

export const suggestionsRenderer = (item: Suggestion): React.JSX.Element => {
  if (typeof item !== 'string') {
    return <RecentSearch recentSearch={item} />;
  }

  if (item === RECENT_SEARCHS_TITLE) {
    return (
      <GroupTitle size="small" sizeConfined="medium">
        <FormattedMessage id="JOBS_SEARCH_RECENT_SEARCHES_TITLE" />
      </GroupTitle>
    );
  }

  return <InstantPrompt useCase={item} />;
};

const GroupTitle = styled(BodyCopy)`
  margin-bottom: -${spaceM};
  color: ${xdlColorTextSecondary};

  @media ${mediaConfined} {
    margin-left: -${spaceS};
  }
`;
